import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { audiences } from '../data/siteData';
import './About.css';

const { FiArrowUpRight } = FiIcons;

function About() {
  return (
    <section className="about-section panel-section" id="about">
      <div className="section-heading">
        <span className="section-index">01 / About</span>
        <h2>Built for the work <em>behind</em> every appointment.</h2>
        <p>Growth Sparrow brings scheduling, customer experience, and day-to-day clarity into one elegant workspace.</p>
      </div>
      <div className="audience-grid">
        {audiences.map((audience, index) => (
          <motion.article
            className={`audience-card audience-card-${index + 1}`}
            key={audience.name}
            whileHover={{ y: -8 }}
            transition={{ type: 'spring', stiffness: 250, damping: 18 }}
          >
            <div className="audience-card-glow" />
            <div className="audience-card-top">
              <span className="audience-number">0{index + 1}</span>
              <span className="audience-card-label">Built for you</span>
            </div>
            <div className="audience-icon">
              <SafeIcon icon={audience.icon} />
            </div>
            <div className="audience-card-content">
              <h3>{audience.name}</h3>
              <p>{audience.count}</p>
            </div>
            <span className="audience-arrow">
              <SafeIcon icon={FiArrowUpRight} />
            </span>
          </motion.article>
        ))}
      </div>
    </section>
  );
}

export default About;